<template>
  <section>
    <h5>{{ $t('DASHBOARD.SERVICES')}}</h5>
    <b-card no-body>

      <services-item minimal="1" v-for="item in items" :item="item" :key="item.id" />

      <b-card-body class="text-center" v-if="items.length == 0">{{ $t('SERVICES.NO_SERVICES')}}</b-card-body>

      <b-card-footer class="clickable text-center">
        <router-link :to="{ name: 'Services' }">
          <i class="fal fa-cubes" />
          {{$t('DASHBOARD.GOTO_SERVICES')}}
        </router-link>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
import ServicesItem from "../Services/ServicesItem";

export default {
  components: {
    ServicesItem
  },
  data() {
    return {
      page: 0,
      limit: 3,
      items: [],
      totalItems: 0,
      user: this.$store.state.auth.user
    };
  },
  methods: {
    getServices: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/list", {
          page: this.page,
          archived: 0,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getServices();
  }
};
</script>
<style>
</style>